riot.tag2('gb-sayt-link', '<a onclick="{opts.send}"> <yield></yield> </a>', '.gb-stylish gb-sayt-link a,.gb-stylish [riot-tag="gb-sayt-link"] a,.gb-stylish [data-is="gb-sayt-link"] a{ padding: 5px 15px; text-decoration: none; display: block; }', '', function(opts) {
});



/** WEBPACK FOOTER **
 ** ./src/tags/sayt/gb-sayt-link.tag.html
 **/